import { api } from './api';

export interface CsatSummary {
  offeredCount: number;
  completedCount: number;
  openedCount: number;
  averageRating?: number | null;
  responseRate?: number | null;
  openRate?: number | null;
  completionRateAmongOpened?: number | null;
}

class CsatService {
  async getSummary(params?: {
    inboxId?: string;
    fromUtc?: string;
    toUtc?: string;
  }): Promise<CsatSummary> {
    const response = await api.get<CsatSummary>('/support/csat/summary', { params });
    return response.data;
  }
}

export const csatService = new CsatService();
